import React, { useState } from 'react';
import { Phone, Mail, MapPin, Send } from 'lucide-react';
export function ContactPanel() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    appliance: '',
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Form submission logic would go here
    alert('Thank you for your enquiry. We will be in touch shortly.');
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <section className="py-16 bg-gray-50" data-id="element-46">
      <div className="max-w-7xl mx-auto px-4" data-id="element-47">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-gray-900" data-id="element-48">
          Get in Touch
        </h2>
        <div className="grid lg:grid-cols-2 gap-12" data-id="element-49">
          <div data-id="element-50">
            <h3 className="text-2xl font-semibold mb-6 text-gray-900" data-id="element-51">
              Send Us a Message
            </h3>
            <form onSubmit={handleSubmit} className="space-y-4" data-id="element-52">
              <div data-id="element-53">
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-54">
                  Full Name
                </label>
                <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D7377] focus:border-transparent outline-none" data-id="element-55" />
              </div>
              <div data-id="element-56">
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-57">
                  Email Address
                </label>
                <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D7377] focus:border-transparent outline-none" data-id="element-58" />
              </div>
              <div data-id="element-59">
                <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-60">
                  Phone Number
                </label>
                <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D7377] focus:border-transparent outline-none" data-id="element-61" />
              </div>
              <div data-id="element-62">
                <label htmlFor="appliance" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-63">
                  Appliance Type
                </label>
                <select id="appliance" name="appliance" value={formData.appliance} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D7377] focus:border-transparent outline-none" data-id="element-64">
                  <option value="" data-id="element-65">Select an appliance</option>
                  <option value="washing-machine" data-id="element-66">Washing Machine</option>
                  <option value="dishwasher" data-id="element-67">Dishwasher</option>
                  <option value="tumble-dryer" data-id="element-68">Tumble Dryer</option>
                  <option value="cooker" data-id="element-69">Cooker/Oven</option>
                  <option value="fridge-freezer" data-id="element-70">Fridge/Freezer</option>
                  <option value="tv" data-id="element-71">Television</option>
                </select>
              </div>
              <div data-id="element-72">
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-73">
                  Message
                </label>
                <textarea id="message" name="message" value={formData.message} onChange={handleChange} rows={4} required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D7377] focus:border-transparent outline-none resize-none" data-id="element-74"></textarea>
              </div>
              <button type="submit" className="w-full bg-[#E8956B] text-white px-6 py-4 rounded-lg font-semibold hover:bg-[#D67D54] transition-colors shadow-md hover:shadow-lg flex items-center justify-center gap-2" data-id="element-75">
                <Send size={20} data-id="element-76" />
                Send Message
              </button>
            </form>
          </div>
          <div data-id="element-77">
            <h3 className="text-2xl font-semibold mb-6 text-gray-900" data-id="element-78">
              Contact Information
            </h3>
            <div className="bg-white p-8 rounded-xl shadow-sm space-y-6" data-id="element-79">
              <div className="flex items-start gap-4" data-id="element-80">
                <div className="w-12 h-12 bg-[#0D7377] bg-opacity-10 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-81">
                  <MapPin className="text-[#0D7377]" size={24} data-id="element-82" />
                </div>
                <div data-id="element-83">
                  <h4 className="font-semibold text-gray-900 mb-1" data-id="element-84">Address</h4>
                  <p className="text-gray-600" data-id="element-85">
                    157 Ashley Rd
                    <br data-id="element-86" />
                    Hale, Altrincham
                    <br data-id="element-87" />
                    WA15 9SD
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4" data-id="element-88">
                <div className="w-12 h-12 bg-[#0D7377] bg-opacity-10 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-89">
                  <Phone className="text-[#0D7377]" size={24} data-id="element-90" />
                </div>
                <div data-id="element-91">
                  <h4 className="font-semibold text-gray-900 mb-1" data-id="element-92">Phone</h4>
                  <a href="tel:08000554969" className="text-[#0D7377] hover:text-[#14919B] font-medium" data-id="element-93">
                    0800 055 4969
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-4" data-id="element-94">
                <div className="w-12 h-12 bg-[#0D7377] bg-opacity-10 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-95">
                  <Mail className="text-[#0D7377]" size={24} data-id="element-96" />
                </div>
                <div data-id="element-97">
                  <h4 className="font-semibold text-gray-900 mb-1" data-id="element-98">Email</h4>
                  <a href="mailto:info@caringhand.it.com" className="text-[#0D7377] hover:text-[#14919B] font-medium" data-id="element-99">
                    info@caringhand.it.com
                  </a>
                </div>
              </div>
              <div className="pt-6 border-t border-gray-200" data-id="element-100">
                <h4 className="font-semibold text-gray-900 mb-3" data-id="element-101">
                  Opening Hours
                </h4>
                <div className="space-y-2 text-sm text-gray-600" data-id="element-102">
                  <div className="flex justify-between" data-id="element-103">
                    <span data-id="element-104">Monday - Friday:</span>
                    <span className="font-medium text-gray-900" data-id="element-105">
                      8:00 AM - 6:00 PM
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-106">
                    <span data-id="element-107">Saturday:</span>
                    <span className="font-medium text-gray-900" data-id="element-108">
                      9:00 AM - 4:00 PM
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-109">
                    <span data-id="element-110">Sunday:</span>
                    <span className="font-medium text-gray-900" data-id="element-111">Closed</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}